var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    !_vm.isStatusCreated
      ? _c("div", { staticClass: "container" }, [
          _c("strong", [_vm._v("Create a new organization admin")]),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "Email" } }, [_vm._v("Email:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "email", placeholder: "Work email of an admin" },
                domProps: { value: _vm.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.email = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "Email", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "FirstName" } }, [
                _vm._v("First name:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.firstName,
                    expression: "firstName",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "First name of an admin" },
                domProps: { value: _vm.firstName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.firstName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "FirstName", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "LastName" } }, [
                _vm._v("Last name:"),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.lastName,
                    expression: "lastName",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: "Last name of an admin" },
                domProps: { value: _vm.lastName },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.lastName = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("ValidationError", {
                attrs: { context: "LastName", errors: _vm.validationErrors },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form-group form-check" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.setInitialPassword,
                  expression: "setInitialPassword",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "setInitialPassword" },
              domProps: {
                checked: Array.isArray(_vm.setInitialPassword)
                  ? _vm._i(_vm.setInitialPassword, null) > -1
                  : _vm.setInitialPassword,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.setInitialPassword,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.setInitialPassword = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.setInitialPassword = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.setInitialPassword = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "setInitialPassword" },
              },
              [_vm._v("Set initial password manually")]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.setInitialPassword,
                  expression: "setInitialPassword",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { attrs: { for: "Password" } }, [
                    _vm._v("Initial password:"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "password" },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("ValidationError", {
                    attrs: {
                      context: "Password",
                      errors: _vm.validationErrors,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.password,
                      expression: "password",
                    },
                  ],
                  staticClass: "form-group",
                },
                [
                  _c("label", { attrs: { for: "PasswordConfirmation" } }, [
                    _vm._v("Initial password confirmation:"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirmation,
                        expression: "passwordConfirmation",
                      },
                    ],
                    staticClass: "form-control",
                    class: { "is-invalid": _vm.passwordConfirmationInvalid },
                    attrs: { type: "password" },
                    domProps: { value: _vm.passwordConfirmation },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.passwordConfirmation = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "invalid-feedback" }, [
                    _vm._v("Initial password confirmation doesn't match"),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStatusNotCreated,
                  expression: "isStatusNotCreated",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: {
                type: "button",
                disabled: _vm.passwordConfirmationInvalid,
              },
              on: { click: _vm.handleCreateUserCommandV1 },
            },
            [_vm._v("Create")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isStatusCreating,
                  expression: "isStatusCreating",
                },
              ],
              staticClass: "btn btn-primary btn-lg",
              attrs: { type: "button", disabled: "" },
            },
            [_vm._v("Creating...")]
          ),
          _vm._v(" "),
          _c("br"),
          _c("br"),
          _vm._v(" "),
          _vm.users.length
            ? _c("div", [
                _c("hr"),
                _vm._v(" "),
                _c("strong", [
                  _vm._v("Set existing user as organization admin"),
                ]),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(_vm.users, function (u) {
                    return _c(
                      "div",
                      {
                        staticClass: "col-md-4 col-sm-6",
                        staticStyle: { "margin-bottom": "20px" },
                      },
                      [
                        _c("div", { staticClass: "card bg-light" }, [
                          _c("div", { staticClass: "card-header" }, [
                            _vm._v(
                              _vm._s(u.FirstName) + " " + _vm._s(u.LastName)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body" }, [
                            _c("p", { staticClass: "card-text" }, [
                              _vm._v(_vm._s(u.Email)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.handleAssignOrganizationAdminRoleCommandV1(
                                      u
                                    )
                                  },
                                },
                              },
                              [_vm._v("Set as admin")]
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h1", [_vm._v("Congratulation!")]),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              "Organization admin account was created and password was sent on email " +
                _vm._s(_vm.email)
            ),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-lg",
              attrs: { href: "/#/admin/organizations/manage", role: "button" },
            },
            [_vm._v("Manage organizations")]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
                "margin-top": "20px",
              },
            },
            [_vm._v("Organization admin setup")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }